import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// web/src/components/chat/templates/DataView.tsx
// "Show me X" queries — chart-first layout. Chart at top, 1-2 line caption.
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Renderer } from "../../../rendering";
export function DataView({ message }) {
    const charts = message.inline_renders ??
        message.specialists?.[0]?.renders ??
        [];
    const caption = message.content?.trim() ?? "";
    return (_jsxs("div", { className: "space-y-2", children: [charts.length > 0 && (_jsx("div", { className: "space-y-2", children: charts.map((b, i) => (_jsx(Renderer, { block: b }, i))) })), caption && (_jsx("div", { className: "text-sm text-slate-300 leading-relaxed", children: _jsx(ReactMarkdown, { remarkPlugins: [remarkGfm], children: caption }) }))] }));
}
